export default "__VITE_ASSET__PfQyol9e__"